module.exports = __webpack_public_path__ + "img/logo.41c29ad8.svg";